import { render, staticRenderFns } from "./UsStep2.vue?vue&type=template&id=3822c54a"
import script from "./UsStep2.vue?vue&type=script&lang=js"
export * from "./UsStep2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports